import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90da7af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orderlines-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "hide-mobile" }, "Varenr", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Varenavn", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "hide-mobile" }, "Pris pr stk", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "hide-mobile" }, "Antall", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Totalt", -1))
const _hoisted_7 = {
  key: 0,
  class: "hide-mobile"
}
const _hoisted_8 = { class: "sim-modal" }
const _hoisted_9 = { class: "sim-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Strekkode", -1))
const _hoisted_11 = { class: "sim-actions" }
const _hoisted_12 = { class: "orderlines" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = { colspan: "4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_OrderLine = _resolveComponent("OrderLine")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          (_ctx.isWeborder)
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Skannet"))
            : _createCommentVNode("", true),
          _createElementVNode("th", null, [
            (_ctx.env !== 'production')
              ? (_openBlock(), _createBlock(_component_TextButton, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.barcodeSimOpen = true)),
                      type: "mdi",
                      path: _ctx.barcodeScanIcon
                    }, null, 8, ["path"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.barcodeSimOpen)
              ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.barcodeSim) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.barcodeSim]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_Button, {
                          color: "gray",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.barcodeSimOpen = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lukk")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Button, {
                          color: "green",
                          onClick: _ctx.simScan
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Scan")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderlines, (orderline) => {
          return (_openBlock(), _createBlock(_component_OrderLine, {
            key: orderline.id,
            orderline: orderline
          }, null, 8, ["orderline"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadingLines, (line) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: line.barcode
          }, [
            _hoisted_13,
            _createElementVNode("td", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(["loading-line", { error: line.error }])
              }, [
                (!line.error)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_SvgIcon, {
                        class: "animate-spin",
                        type: "mdi",
                        path: _ctx.loadingIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", null, _toDisplayString(line.barcode), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_SvgIcon, {
                        type: "mdi",
                        path: _ctx.errorIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", null, _toDisplayString(line.error), 1)
                    ], 64))
              ], 2)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}